export const isEncrypted = (value: string): boolean => {
  // As an encrypted string is Base64 encoded, it will not contain double quotes
  return !value.includes('"');
};
